/**
 * Tinta di girone.
 *
 * Derivata dalla rampa di brand (blu / navy / oro / clay) invece di un
 * arcobaleno di tinte indipendenti (rosa, viola, teal, verde…): serve a
 * distinguere i gironi restando dentro l'identità della Lega.
 * Ogni coppia accento/testo è scelta per rispettare il contrasto AA (≥ 4.5:1).
 */
type PoolTheme = { accent: string; foreground: string }

const BRAND_TINTS = {
  blue: { accent: '#2f6ac4', foreground: '#ffffff' }, // 5.28
  navy: { accent: '#1e3a5f', foreground: '#ffffff' }, // 11.50
  gold: { accent: '#f4b400', foreground: '#1f2937' }, // 7.95
  clay: { accent: '#b8561c', foreground: '#ffffff' }, // 4.79
} satisfies Record<string, PoolTheme>

const TINT_BY_SLUG: Record<string, keyof typeof BRAND_TINTS> = {
  scf_a: 'gold',
  'serie-c-femminile-girone-a': 'gold',
  scf_b: 'clay',
  'serie-c-femminile-girone-b': 'clay',

  scm_a: 'blue',
  'serie-c-maschile-girone-a': 'blue',
  scm_b: 'navy',
  'serie-c-maschile-girone-b': 'navy',

  sdf_a: 'clay',
  'serie-d-femminile-girone-a': 'clay',
  sdf_b: 'navy',
  'serie-d-femminile-girone-b': 'navy',
  sdf_c: 'gold',
  'serie-d-femminile-girone-c': 'gold',

  sdm_a: 'blue',
  'serie-d-maschile-girone-a': 'blue',
  sdm_b: 'navy',
  'serie-d-maschile-girone-b': 'navy',
}

export function getPoolTheme(poolSlug: string): PoolTheme | null {
  const tint = TINT_BY_SLUG[poolSlug]
  return tint ? BRAND_TINTS[tint] : null
}

export function getPoolAccentColor(poolSlug: string): string | null {
  return getPoolTheme(poolSlug)?.accent ?? null
}
